import * as React from 'react';
import { cn, getInitials } from '@soundbyte/config';

interface AvatarProps extends React.HTMLAttributes<HTMLDivElement> {
  src?: string | null;
  alt?: string;
  fallback?: string;
  size?: 'sm' | 'md' | 'lg' | 'xl';
}

const sizeClasses = {
  sm: 'h-8 w-8 text-xs',
  md: 'h-10 w-10 text-sm',
  lg: 'h-12 w-12 text-base',
  xl: 'h-16 w-16 text-lg',
};

const Avatar = React.forwardRef<HTMLDivElement, AvatarProps>(
  ({ className, src, alt = '', fallback = '', size = 'md', ...props }, ref) => {
    const [hasError, setHasError] = React.useState(false);

    const showFallback = !src || hasError;
    const initials = fallback ? getInitials(fallback) : alt ? getInitials(alt) : '?';

    return (
      <div
        ref={ref}
        className={cn(
          'relative flex shrink-0 overflow-hidden rounded-full bg-muted',
          sizeClasses[size],
          className
        )}
        {...props}
      >
        {showFallback ? (
          <div className="flex h-full w-full items-center justify-center bg-primary/10 text-primary font-medium">
            {initials}
          </div>
        ) : (
          <img
            src={src}
            alt={alt}
            className="aspect-square h-full w-full object-cover"
            onError={() => setHasError(true)}
          />
        )}
      </div>
    );
  }
);
Avatar.displayName = 'Avatar';

export { Avatar };
